export const cardShadow = '#0E121B1A';
export const successColor = '#43C759';
export const lightColor = '#F5F7FA';
export const mpTextColorDark = '#525866';
export const darkColor = '#0E121B';
export const primaryColor = '#AF52DE';
export const thirdColor = '#335CFF';
export const fourthColor = '#3D1D86';
export const thirdColorLight = '#EBF1FF';
export const mpTextColorLight = '#99A0AE';
export const secondaryColor = '#CFC7CF';
export const dangerColor = '#FB3748';
export const warningColor = '#F89B05';
